import { useState, useEffect } from 'react';

/**
 * Custom hook for managing "Select All" functionality
 * @param {Array} items - Array of items to select from
 * @param {string} idKey - Key to use for item identification (e.g., 'uid', 'conversationId')
 * @param {Array} selectedItems - Currently selected items
 * @param {Function} setSelectedItems - Function to update selected items
 * @returns {Object} - Object containing selectAll state and toggle function
 */
export const useSelectAll = (items, idKey, selectedItems, setSelectedItems) => {
  const [selectAll, setSelectAll] = useState(false);

  // Handle "Select All" toggle
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      const allItemIds = items.map((item) => item[idKey]);
      setSelectedItems(allItemIds);
    }
    setSelectAll(!selectAll);
  };

  // Update selectAll state when individual selections change
  useEffect(() => {
    const totalItems = items.length;
    if (selectedItems.length === 0) {
      setSelectAll(false);
    } else if (selectedItems.length === totalItems && totalItems > 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, items]);

  return {
    selectAll,
    handleSelectAll,
  };
};
